(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/signup', {
      templateUrl: 'modules/outside/signup/signup.html',
      controller: 'SignUpCtrl'
    });
  }]).controller('SignUpCtrl', ['$scope', '$http', '$window', 'Validation', 'Utils', 'User', 'Logger', 'wsApiUrl', function ($scope, $http, $window, Validation, Utils, User, Logger, wsApiUrl) {
    $scope.newUser = {};
    $scope.newOrg = {};
    $scope.formErrors = null;
    $scope.signupFormSubmitted = false;
    $scope.settingUpOrg = false;
    function validateForm($scope) {
      return Validation.validate({
        "first name": {
          "rules": {
            "required": true
          },
          "value": $scope.newUser.firstName
        },
        "last name": {
          "rules": {
            "required": true
          },
          "value": $scope.newUser.lastName
        },
        "company name": {
          "rules": {
            "required": true
          },
          "value": $scope.newOrg.name,
          "display": "Organization name"
        },
        "email": {
          "rules": {
            "required": true,
            "email": true
          },
          "value": $scope.newUser.email
        },
        "password": {
          "rules": {
            "required": true,
            "password": true
          },
          "value": $scope.newUser.password
        },
        "passwordConfirm": {
          "rules": {
            "required": true,
            "matches": "password"
          },
          "display": "Confirm password",
          "value": $scope.newUser.passwordConfirm
        }
      });
    }
    var userCreated = false;
    var createUser = function createUser() {
      if (userCreated) {
        //if a user was already created just try to create the organization
        //this only happens if the org creation fails
        createOrganization();
        return;
      }
      $http.post(wsApiUrl + "/users", $scope.newUser).then(function createUserSuccess() {
        userCreated = true;
        createOrganization();
      }, function createUserError(response) {
        $scope.signupFormSubmitted = false;

        // If we hit a conflict, try these credentials and see if they work.
        // If they do, then just go ahead and create the org. Otherwise, error out.
        if (response.status === 409) {
          var authHeaders = {
            "Authorization": "Basic " + Utils.base64encode($scope.newUser.email + ":" + $scope.newUser.password)
          };
          return $http.post(wsApiUrl + "/login", null, {
            headers: authHeaders
          }).then(function loginSuccess() {
            userCreated = true;
            createOrganization();
          }, function loginFail() {
            $scope.signupError = "A user with that email already exists.";
          });

          // Otherwise, it's just some other signup error...
        } else {
          var errorMsg = "There was an error creating your account.";
          if (response.status < 500 && response.data && response.data.message) {
            errorMsg += " " + response.data.message;
          }
          $scope.signupError = errorMsg;
        }
      });
    };
    var createOrganization = function createOrganization() {
      $scope.settingUpOrg = true;
      var authHeaders = {
        "Authorization": "Basic " + Utils.base64encode($scope.newUser.email + ":" + $scope.newUser.password)
      };
      $http.post(wsApiUrl + "/organizations", $scope.newOrg, {
        headers: authHeaders
      }).then(function createOrgSuccess() {
        $scope.tryLogin($scope.newUser.email, $scope.newUser.password);
      }, function createOrgError(response) {
        $scope.settingUpOrg = false;
        $scope.signupFormSubmitted = false;
        $scope.signupError = "There was an error creating your account.";
        if (response.status === 409) {
          $scope.formErrors = {
            'company name': "Please select a different organization name"
          };
          $scope.signupError = "Please select a different organization name";
        }
      });
    };
    $scope.signup = function signup() {
      $scope.signupFormSubmitted = true;
      $scope.signupError = null;
      $scope.formErrors = validateForm($scope);
      if ($scope.formErrors !== null) {
        $scope.signupFormSubmitted = false;
        $scope.signupError = "Please review the fields above for errors";
        return;
      }
      $scope.newUser.username = $scope.newUser.email;
      $scope.newUser.name = $scope.newUser.firstName + " " + $scope.newUser.lastName;
      createUser();
    };
    $scope.googleSignup = function googleSignup() {
      $window.location.href = $scope.getExternalLoginUrl('google', null, Utils.qualifyURL("#/signin"));
    };
  }]);
})();
